<div [@fadeAnimation]="outlet.isActivated ? outlet.activatedRoute : ''">
  <router-outlet #outlet="outlet"></router-outlet>
</div>
